/*
 * Asynchronous local storage
 */

export const asyncLocalStorage = {
  setItem: async (key: string, value: string) => {
    try {
      return await localStorage.setItem(key, value);
    } catch (e) {
      console.log({ '`Storage Util Error\nSet Item`': e });
    }
  },
  getItem: async (key: string) => {
    try {
      return await localStorage.getItem(key);
    } catch (e) {
      console.log({ '`Storage Util Error\nGet Item:`': e });
    }
  },
};
